var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable, named } from 'inversify';
import { ContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { CustomFieldActionContribution } from './custom-field-action-contribution.interface';
function isEnabled(context) {
    return true;
}
function isVisible(context) {
    return true;
}
let CustomFieldActionRegistryImpl = class CustomFieldActionRegistryImpl extends AbstractModel {
    constructor(_contributionProvider) {
        super();
        this._contributionProvider = _contributionProvider;
        this._modelData = { actions: [] };
        this._commandIds = new Set();
    }
    clone(modelData) {
        const data = { actions: modelData.actions.map(_ => {
                return { ..._ };
            }) };
        return data;
    }
    dispose() {
        this._commandIds.clear();
        this.update(() => ({ actions: [] }));
    }
    onStart() {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerCustomFieldActions(this);
        });
    }
    getCustomFieldActions() {
        const actions = this.modelData.actions;
        return actions.sort((a, b) => a.order - b.order);
    }
    registerCustomFieldAction(action) {
        if (this._commandIds.has(action.commandId)) {
            console.warn(`custom field action with command ID ${action.commandId} already exists.`);
            return Disposable.NULL;
        }
        const actions = this.modelData.actions;
        const _action = this._normalizeAction(action);
        actions.push(_action);
        this.update(() => ({ actions }));
        this._commandIds.add(action.commandId);
        return {
            dispose: () => {
                this._disposeAction(action);
            },
        };
    }
    _normalizeAction(action) {
        return {
            ...action,
            isEnabled: action.isEnabled || isEnabled,
            isVisible: action.isVisible || isVisible,
            order: action.order || 0,
        };
    }
    _disposeAction(action) {
        const actions = this.modelData.actions;
        const index = actions.findIndex(a => a.commandId === action.commandId);
        if (index !== -1) {
            actions.splice(index, 1);
            this.update(() => ({ actions }));
            this._commandIds.delete(action.commandId);
        }
    }
};
CustomFieldActionRegistryImpl = __decorate([
    injectable(),
    __param(0, inject(ContributionProvider)),
    __param(0, named(CustomFieldActionContribution)),
    __metadata("design:paramtypes", [typeof (_a = typeof ContributionProvider !== "undefined" && ContributionProvider) === "function" ? _a : Object])
], CustomFieldActionRegistryImpl);
export { CustomFieldActionRegistryImpl };
